<script>
    import {clickOutside} from '../lib/clickOutside.js';
    import {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import cart from "../stores/cart";
    import user from "../stores/user";
    // import {APP_VERSION} from "../lib/constants";
    import AppIcon from "./icons/AppIcon.svelte";

    let showUserDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeUserDropdown();
        }
    }

    const logOut = () => {
        showUserDropdown = false;
        user.clearToken();
        router.go('/')();
    }

    const toggleCart = () => {
        setTimeout(function () {
            $cart.show = !$cart.show;
        }, 100);
    }

    const toggleMenu = () => {
        $app.menuExpanded = $app.menuExpanded > 0 ? 0 : 2;
    }

    const toggleUserDropdown = () => {
        if (!$user.token) {
            $user.showLogin = true;
            return;
        }
        
        if (!showUserDropdown) {
            showUserDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeUserDropdown = () => {
        showUserDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const openPage = page => {
        $app.menuExpanded = 0;
        router.go(page)()
    }
</script>

<header>
    <!--    <div class="container">-->
    <div class="top-bar">
        <div class="main-menu">
            <div class="menu-toggler hidden-xl hidden-lg hidden-md" on:click={ toggleMenu }>
                <i class="fa fa-bars"></i>
            </div>
            <div class="menu-content" class:show={ $app.menuExpanded }>
                <div class="menu-item" on:click={ () => openPage('/') }>
                    Υπηρεσίες - Προϊόντα
                </div>
                <div class="menu-item" on:click={ () => openPage('/documents') }>
                    Έγγραφα Μελών
                </div>
                {#if $user.token}
                    <div class="menu-item" on:click={ () => openPage('/my-account') }>
                        Ο Λογαριασμός μου
                    </div>
                {:else}
                    <div class="menu-item" on:click={ toggleUserDropdown }>
                        Είσοδος
                    </div>
                    <a href="/signup" class="menu-item">
                        Εγγραφή
                    </a>
                {/if}
            </div>
        </div>
        <div class="content-right">
            <div class="menu-item" on:click={ toggleCart }>
                <AppIcon icon="cart-solid" size="16"/>
                {#if $cart.total_products > 0}
                    <div class="badge">{ $cart.total_products }</div>
                {/if}
            </div>
            {#if !$user.token}
                <div class="menu-item" on:click="{ toggleUserDropdown }">
                    <AppIcon icon="user" size="16"/>
                </div>
            {:else}
                <div class="user-menu-item dropdown-container" on:click="{ toggleUserDropdown }">
                    <div class="acronym">{ user.acronym() }</div>
                    {#if showUserDropdown}
                        <ul class="dropdown right" use:clickOutside on:click_outside="{ closeUserDropdown }">
                            <li class="p-3">
                                <div class="fs-6">{ $user.lastname } { $user.firstname }</div>
                                <div class="text-muted">{ $user.email }</div>
                            </li>
                            <li class="separator"></li>
                            <li class="dropdown-item pointer text-center"  on:click={ () => openPage('/my-orders') }>
                                Οι παραγγελίες μου
                            </li>
                            <li class="dropdown-item pointer text-center" on:click="{ logOut }">
                                Αποσύνδεση
                            </li>
                        </ul>
                    {/if}
                </div>
            {/if}
        </div>
    </div>
    <!--    </div>-->
</header>

<style>
    header {
        position: fixed;
        display: flex;
        align-items: center;
        height: var(--header-height);
        width: 100%;
        font-family: var(--secondary-font);
        background-color: #09285f;
        border-bottom: 5px solid #96bf59;
        z-index: 8000;
    }

    /*header .container {*/
    /*    padding-left: 0;*/
    /*    padding-right: 0;*/
    /*}*/

    header .top-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 0;
    }

    .main-menu .menu-toggler {
        font-size: 20px;
        color: #fff;
        padding: 8px 15px;
    }

    .main-menu .menu-content {
        display: flex;
        align-items: center;
    }

    .main-menu .menu-content.show {
        transform: translateX(100%);
    }

    .content-right {
        display: flex;
        align-items: center;
        padding-right: 15px;
    }

    header .menu-item {
        position: relative;
        color: #fff;
        padding: 0 15px;
        display: flex;
        align-items: center;
        min-width: 50px;
        height: 45px;
        cursor: pointer;
    }

    header .menu-item:hover {
        background: #96bf59;
    }

    header .menu-item .badge {
        position: absolute;
        width: 18px;
        height: 18px;
        right: 5px;
        bottom: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #96bf59;
        border-radius: 50%;
        font-size: 0.7rem;
        line-height: 0;
        padding: 0;
    }

    header .user-menu-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        background: #96bf59;
        border-radius: 50%;
        margin-left: 10px;
        cursor: pointer;
    }

    header .user-menu-item .acronym {
        color: #fff;
    }

    header .user-menu-item .dropdown-item {
        border-bottom: 1px solid #ebebeb;
    }

    header .user-menu-item .dropdown-item:last-child {
        border-bottom: none;
    }

    @media (max-width: 576px) {
        .main-menu .menu-content {
            position: absolute;
            display: block;
            width: 100%;
            height: calc(100vh - 48px);
            left: -100%;
            background: #09285f;
            transition: .3s all ease;
        }

        header .menu-item {
            padding: 0 20px;
        }
    }
</style>